import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { corporate_landing_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';
import { OfferOption } from '@utils/backend-api/subscribe';

import { OfferSelectionProps } from '..';
import OfferPrice from '../OfferTable/OfferPrice';
import OfferCard from './OfferCard';

type OfferCardsProps = Omit<OfferSelectionProps, 'offers' | 'reporters' | 'suggestedAiPrompts'> & {
  idPrefix?: string;
  showGroup?: boolean;
  showYP?: boolean;
};

const OfferCards = ({
  idPrefix = '',
  offerTitleClass,
  onOfferClick,
  setSelectedOffer,
  showGroup = true,
  showYP = true,
  ypOffer,
}: OfferCardsProps) => {
  const { trackEvent } = useEventTracking({ location: TrackingLocation.OfferCards });

  const handleOfferClick = ({
    billingFrequency,
    code,
    currentPrice,
    isPro,
    originalPrice,
    title,
  }: OfferOption) => {
    setSelectedOffer({
      billingFrequency,
      code,
      currentPrice,
      isPro,
      originalPrice,
      title,
    });
    trackEvent(
      click({ clickTarget: ClickTarget.Offer, offerCode: code, clickText: ClickTarget.Subscribe })
    );
    onOfferClick();
  };

  const handleGroupSubscriptionClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.GroupSubscription, clickText: 'Explore options' }));
    window.location.href = corporate_landing_path();
  };

  return (
    <div className="mt-64">
      {showYP && (
        <OfferCard
          buttonText="Subscribe"
          className="mt-24"
          description={ypOffer.description}
          highlight="30 or under?"
          id={`${idPrefix}${ypOffer.code}`}
          offerPrice={<OfferPrice offer={ypOffer} />}
          onButtonClick={() => handleOfferClick(ypOffer)}
          offerTitleClass={offerTitleClass}
          title={ypOffer.title}
        />
      )}
      {showGroup && (
        <OfferCard
          buttonText="Explore options"
          className="mt-24"
          description="Subscription discounts based on group size."
          id={`${idPrefix}group_subscriptions`}
          onButtonClick={handleGroupSubscriptionClick}
          offerTitleClass={offerTitleClass}
          title="Group Subscription"
        />
      )}
    </div>
  );
};

export default OfferCards;
